import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import {makeStyles} from '@mui/styles';
import Link from '@mui/material/Link';

const useStyles= makeStyles(theme=>({
    socialIconStyle:{
        color:'#a8b2d1',
        '&:hover':{
            color:'#64ffda'
        }

    },
    socialContainer:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        position:'fixed',
        bottom:0,
        left:'20px'
    }
}))

const SocialContainer = () => {
    const classes = useStyles();
    return (
        <div>
            <Box className={classes.socialContainer} >
                
                        <IconButton><Link target="_blank" href={"https://github.com/Suprith461"}><GitHubIcon   className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.linkedin.com/in/suprith-hattikal-983b011a1/"}><LinkedInIcon className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.instagram.com/suprith.p.h/"}><InstagramIcon className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://twitter.com/p_suprith"}><TwitterIcon  className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.facebook.com/profile.php?id=100009023124792"}><FacebookIcon className={classes.socialIconStyle}/></Link></IconButton>
                        
                        <Divider orientation="vertical"  style={{color:'white',height:'150px',backgroundColor:'white',display:'flex'}}/>

                        
            </Box>
        </div>
    )
}

export default SocialContainer
